// TeamViewToggle.js - FIXED: Prevents page refresh
import React from 'react';
import { Users, User } from 'lucide-react';

const TeamViewToggle = ({ 
  viewMode, 
  onViewModeChange, 
  userRole, 
  teamMemberCount = 0,
  className = "" 
}) => {
  if (userRole !== 'admin' && userRole !== 'manager') {
    return null;
  }

  const isTeamView = viewMode === 'team';
  const isMyView = viewMode === 'my';

  // CRITICAL FIX: Prevent default and stop propagation
  const handleClick = (e, mode) => {
    e.preventDefault();
    e.stopPropagation();
    onViewModeChange(mode);
  };

  return (
    <div className={`flex items-center bg-slate-100 rounded-lg p-1 ${className}`}>
      <button
        type="button"
        onClick={(e) => handleClick(e, 'my')}
        className={`flex items-center space-x-2 px-3 py-2 rounded-md transition-all duration-200 ${
          isMyView
            ? 'bg-white text-slate-800 shadow-sm'
            : 'text-slate-600 hover:text-slate-800'
        }`}
      >
        <User className="w-4 h-4" />
        <span className="text-sm font-medium">My Entries</span>
      </button>
      
      <button
        type="button"
        onClick={(e) => handleClick(e, 'team')}
        className={`flex items-center space-x-2 px-3 py-2 rounded-md transition-all duration-200 ${
          isTeamView
            ? 'bg-white text-slate-800 shadow-sm'
            : 'text-slate-600 hover:text-slate-800'
        }`}
      >
        <Users className="w-4 h-4" />
        <span className="text-sm font-medium">Team Entries</span>
        {isTeamView && teamMemberCount > 0 && (
          <span className="ml-1 px-1.5 py-0.5 text-xs bg-blue-100 text-blue-700 rounded-full">
            {teamMemberCount}
          </span>
        )}
      </button>
    </div>
  );
};

export default TeamViewToggle;